export enum eUserSituation {
    Active,
    NearToDue,
    Overdue,
    Blocked
}